import { programFullSchema } from '@mio/shared';
import { queryOptions } from '@tanstack/react-query';

import { apiRequest } from '../client';

export const programKeys = {
  all: ['program'] as const,
  full: () => ['program', 'full'] as const,
};

/**
 * The whole program in one request: content plus this learner's progress.
 * Every program, module, lesson and list view derives from this cache, so navigation
 * is instant once it has loaded. Content only changes on sync, so it can stay fresh for a long time.
 */
export const programFullQuery = queryOptions({
  queryKey: programKeys.full(),
  queryFn: ({ signal }) => apiRequest('/program/full', programFullSchema, { signal }),
  staleTime: 10 * 60_000,
  gcTime: 60 * 60_000,
});
